import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { ChangeEventHandler, ReactNode, useId, useState } from 'react';
import { TextArea } from './TextArea';

export interface StandaloneTextArea extends StandaloneComponentProps<typeof TextArea> {
  caption?: ReactNode;
  label?: ReactNode;
  rows?: number;
  status?: 'error';
}

export const StandaloneTextArea: StandaloneComponent<StandaloneTextArea> = ({
  label,
  rows,
  status,
  caption,
  ...props
}) => {
  const [isFilled, setFilled] = useState(false);
  const id = useId();

  const handleChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => {
    setFilled(Boolean(event.target.value));
    props.options?.$input?.onChange?.(event);
  };

  return (
    <TextArea data-status={status || undefined} data-filled={isFilled ? '' : undefined} {...props}>
      <TextArea.Group>
        {label && <TextArea.Label htmlFor={id}>{label}</TextArea.Label>}
        <TextArea.Input rows={rows ?? 5} id={id} onChange={handleChange} />
      </TextArea.Group>
      {caption && <TextArea.Caption>{caption}</TextArea.Caption>}
    </TextArea>
  );
};
